import axios from "axios";

// Vide en prod (service unique) → l'API est servie en same-origin sur /api.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

// Chemin secret du back-office (configurable sans toucher au code).
export const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || "bo-yum";

// Numéro WhatsApp Business YÜM (format international sans « + » pour wa.me).
export const WHATSAPP = (process.env.REACT_APP_WHATSAPP || "596696696896").replace(/\D/g, "");

export const getPhone = () => localStorage.getItem("yum_phone") || "";
export const setPhone = (p) => localStorage.setItem("yum_phone", p);
export const clearPhone = () => localStorage.removeItem("yum_phone");

export const api = axios.create({ baseURL: API });

// Sessions signées côté serveur (login → token avec expiration).
export const adminApi = (token) =>
  axios.create({ baseURL: API, headers: { "X-Admin-Token": token } });

export const caisseApi = (token) =>
  axios.create({ baseURL: API, headers: { "X-Caisse-Token": token } });

// --- Comptes joueurs (téléphone + mot de passe) ---
const PLAYER_TOKEN = "yum_player_token";
const PLAYER_INFO = "yum_player";

export const getPlayer = () => {
  try { return JSON.parse(localStorage.getItem(PLAYER_INFO) || "null"); } catch { return null; }
};
export const getPlayerToken = () => localStorage.getItem(PLAYER_TOKEN) || "";
export const setPlayer = (token, info) => {
  localStorage.setItem(PLAYER_TOKEN, token);
  localStorage.setItem(PLAYER_INFO, JSON.stringify(info));
  if (info?.phone) setPhone(info.phone);
};
export const clearPlayer = () => {
  localStorage.removeItem(PLAYER_TOKEN);
  localStorage.removeItem(PLAYER_INFO);
};

export const playerApi = (token) =>
  axios.create({ baseURL: API, headers: { "X-Player-Token": token || getPlayerToken() } });

// --- Manicou Runner (P3) : récompense du jour, fin de partie, pub dans le décor ---

// Objectif du jour selon la difficulté (image + seuil du gain, ou mode mystère).
export const rewardToday = (difficulty = "") =>
  api.get(`/reward/today${difficulty ? `?difficulty=${encodeURIComponent(difficulty)}` : ""}`)
    .then((r) => r.data);

// Fin de partie : le serveur décide du gain (stocks/quotas/anti-triche) → {won, spin_id?, ...}.
// Envoie le token joueur s'il existe (quotas par téléphone).
export const runnerFinish = (payload) =>
  playerApi().post("/runner/finish", payload).then((r) => r.data);

// Emplacements pub actifs pour une scène (les yum_protected reçoivent campaign=null).
export const adsActive = (scene = "runner") =>
  api.get(`/ads/active?scene=${encodeURIComponent(scene)}`).then((r) => r.data);

// Impression pub (best-effort : n'interrompt jamais le jeu).
export const adImpression = (payload) =>
  api.post("/ads/impression", payload).then((r) => r.data).catch(() => ({ ok: false }));

// --- Back-office P5 : récompenses, planning, difficulté, pub (client = adminApi(token)) ---

// Récompenses (catalogue Runner)
export const adminRewards = (c) => c.get("/admin/rewards").then((r) => r.data);
export const adminRewardSave = (c, body, id) =>
  (id ? c.put(`/admin/rewards/${id}`, body) : c.post("/admin/rewards", body)).then((r) => r.data);
export const adminRewardDelete = (c, id) => c.delete(`/admin/rewards/${id}`).then((r) => r.data);

// Réglages (seuils, difficulté, tirage)
export const adminRewardSettings = (c) => c.get("/admin/reward-settings").then((r) => r.data);
export const adminRewardSettingsSave = (c, body) =>
  c.put("/admin/reward-settings", body).then((r) => r.data);

// Gains gagnables par niveau de difficulté (vue difficulté → lots)
export const adminDifficultyGains = (c) => c.get("/admin/difficulty-gains").then((r) => r.data);
export const adminSetDifficultyGains = (c, level, reward_ids) =>
  c.put(`/admin/difficulty/${level}/gains`, { reward_ids }).then((r) => r.data);

// Planning quotidien
export const adminDailyPlan = (c, day = "") =>
  c.get(`/admin/daily-plan${day ? `?day=${encodeURIComponent(day)}` : ""}`).then((r) => r.data);
export const adminDailyPlanSet = (c, body) => c.post("/admin/daily-plan", body).then((r) => r.data);
export const adminDailyPlanDraw = (c, day = "") =>
  c.post(`/admin/daily-plan/draw${day ? `?day=${encodeURIComponent(day)}` : ""}`).then((r) => r.data);
export const adminDailyPlanHistory = (c, days = 30) =>
  c.get(`/admin/daily-plan/history?days=${days}`).then((r) => r.data);

// Publicité : campagnes
export const adminAdCampaigns = (c) => c.get("/admin/ad-campaigns").then((r) => r.data);
export const adminAdCampaignSave = (c, body, id) =>
  (id ? c.put(`/admin/ad-campaigns/${id}`, body) : c.post("/admin/ad-campaigns", body)).then((r) => r.data);
export const adminAdCampaignDelete = (c, id) => c.delete(`/admin/ad-campaigns/${id}`).then((r) => r.data);

// Publicité : emplacements
export const adminAdPlacements = (c, scene = "") =>
  c.get(`/admin/ad-placements${scene ? `?scene=${encodeURIComponent(scene)}` : ""}`).then((r) => r.data);
export const adminAdPlacementSave = (c, body, id) =>
  (id ? c.put(`/admin/ad-placements/${id}`, body) : c.post("/admin/ad-placements", body)).then((r) => r.data);
export const adminAdPlacementDelete = (c, id) => c.delete(`/admin/ad-placements/${id}`).then((r) => r.data);

// Statistiques
export const adminAdsStats = (c, days = 0) =>
  c.get(`/admin/ads/stats${days ? `?days=${days}` : ""}`).then((r) => r.data);
export const adminRewardsStats = (c) => c.get("/admin/rewards/stats").then((r) => r.data);

// Collecte progressive du profil (utilisateurs à compte : identifiés par le token joueur)
export const profileQuestion = () => playerApi().get("/profile-question").then((r) => r.data);
export const profileAnswer = (body) => playerApi().post("/profile-answer", body).then((r) => r.data);

// Utilisateurs & bons regroupés
export const adminUsers = (c, q = "") => c.get(`/admin/users${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => r.data);
export const adminUser = (c, phone) => c.get(`/admin/user/${encodeURIComponent(phone)}`).then((r) => r.data);
export const adminVoucherToggle = (c, code) => c.post(`/admin/voucher/${encodeURIComponent(code)}/toggle`).then((r) => r.data);
export const adminVoucherAdd = (c, body) => c.post("/admin/voucher/add", body).then((r) => r.data);

// Upload média (image/pub) → renvoie { url, filename, size }
export const adminMediaUpload = (c, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return c.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
